import PropTypes from "prop-types";
import {
  Input,
  ButtonGroup,
  CancelButton,
  ConfirmButton,
  ErrorText,
  Header,
  ModalWrapper,
} from "./AddCategoryModalStyled";
import { ErrorIcon } from "../../assets/icons";

const AddCategoryModal = ({
  isOpen,
  categoryName,
  setCategoryName,
  error,
  onCancel,
  onCreate,
  header = "Create new Template Category",
  placeholder = "Category Name",
  confirmLabel = "Create",
}) => {
  return (
    <ModalWrapper
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      centered
      data-testid="add-category-modal"
    >
      <Header>{header}</Header>
      <Input
        type="text"
        placeholder={placeholder}
        value={categoryName}
        onChange={(e) => setCategoryName(e.target.value)}
        $error={Boolean(error)}
      />
      {error && (
        <ErrorText>
          <ErrorIcon />
          {error}
        </ErrorText>
      )}
      <ButtonGroup>
        <CancelButton onClick={onCancel}>Cancel</CancelButton>
        <ConfirmButton onClick={onCreate}>{confirmLabel}</ConfirmButton>
      </ButtonGroup>
    </ModalWrapper>
  );
};

AddCategoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  categoryName: PropTypes.string.isRequired,
  setCategoryName: PropTypes.func.isRequired,
  error: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  header: PropTypes.string,
  placeholder: PropTypes.string,
  confirmLabel: PropTypes.string,
};

export default AddCategoryModal;
